export enum InvoiceType {
  MOBILE,
  GOODS,
  STATE_FEES,
  FINANCE,
  DEBT,
  TELESERVICES,
  PENALTY,
  BUSINESS
}
